// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner__2TFqH"};